import { Car360Viewer } from "components/Car360Viewer";
import { mediaUrl } from "lib/media";

const buickBreakdown = mediaUrl("website_files/3DS/BreakdownBuick.jpg");
const buickVideo = mediaUrl("website_files/3DS/buick.mp4");

export const ThreeDS = () => {
  return (
    <div className="bg-background text-foreground">
      <section className="border-b border-white/10">
        <div className="page-shell py-20 sm:py-28 lg:py-32">
          <div className="grid gap-10 lg:grid-cols-12 lg:items-end lg:gap-8">
            <div className="lg:col-span-8">
              <p className="eyebrow reveal-up">Automotive visualization</p>
              <h1 className="page-title reveal-up reveal-delay-1 mt-7">
                3DExcite.
              </h1>
            </div>
            <p className="reveal-up reveal-delay-2 max-w-xl text-sm leading-7 text-white/50 lg:col-span-4 lg:pb-2">
              At 3Dexcite, I worked on CG rendering and compositing for
              automotive clients including Chevrolet and Buick, contributing to
              imagery used across web and advertising campaigns, including most
              of the vehicle imagery currently seen on chevy.com and buick.com.
              Much of this work is covered by client NDAs and can&apos;t be
              shown publicly here. What&apos;s featured below represents a
              small, cleared sample of my contributions.
            </p>
          </div>
        </div>
      </section>

      <section className="page-shell py-16 sm:py-24 lg:py-28">
        <article className="border-b border-white/10 pb-16 sm:pb-24 lg:pb-28">
          <div className="mb-8 flex flex-col justify-between gap-5 sm:flex-row sm:items-end">
            <div>
              <p className="text-xs font-semibold text-ember">PROJECT / 01</p>
              <h2 className="mt-5 text-3xl font-semibold tracking-[-0.035em] sm:text-5xl">
                Chevrolet Silverado ZR2
              </h2>
            </div>
            <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/40">
              Drag · Swipe · Arrow keys
            </p>
          </div>

          <Car360Viewer />

          <div className="mt-6 flex flex-col justify-between gap-3 border-t border-white/10 pt-5 text-xs uppercase tracking-[0.16em] text-white/40 sm:flex-row">
            <span>Interactive 360° turntable</span>
            <span>30 rendered frames</span>
          </div>
        </article>

        <article className="pt-16 sm:pt-24 lg:pt-28">
          <div className="mb-8 flex flex-col justify-between gap-5 sm:flex-row sm:items-end">
            <div>
              <p className="text-xs font-semibold text-ember">PROJECT / 02</p>
              <h2 className="mt-5 text-3xl font-semibold tracking-[-0.035em] sm:text-5xl">
                Buick Look Development
              </h2>
            </div>
            <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/40">
              Lighting · Materials · Compositing
            </p>
          </div>

          <div className="grid gap-4 lg:grid-cols-2">
            <figure>
              <div className="relative aspect-video overflow-hidden border border-white/10 bg-black">
                <video
                  className="h-full w-full object-contain"
                  src={buickVideo}
                  controls
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  aria-label="Buick look development animation"
                >
                  Your browser does not support embedded video.
                </video>
                <span className="pointer-events-none absolute left-4 top-4 bg-black/55 px-3 py-2 text-[10px] font-bold uppercase tracking-[0.18em] text-white/70 backdrop-blur-md">
                  Beauty animation
                </span>
              </div>
              <figcaption className="mt-4 text-[10px] font-bold uppercase tracking-[0.16em] text-white/40">
                Final rendered sequence
              </figcaption>
            </figure>

            <figure>
              <div className="relative grid aspect-video place-items-center overflow-hidden border border-white/10 bg-black">
                <img
                  className="h-[86%] w-[86%] object-contain"
                  src={buickBreakdown}
                  alt="Buick lighting render-pass breakdown showing bounce, diffuse, wheels, beauty, bumper, reflection, and ambient occlusion layers"
                  loading="lazy"
                  decoding="async"
                />
                <span className="pointer-events-none absolute left-4 top-4 bg-black/55 px-3 py-2 text-[10px] font-bold uppercase tracking-[0.18em] text-white/70 backdrop-blur-md">
                  Render passes
                </span>
              </div>
              <figcaption className="mt-4 text-[10px] font-bold uppercase tracking-[0.16em] text-white/40">
                Lighting and material breakdown
              </figcaption>
            </figure>
          </div>
        </article>
      </section>
    </div>
  );
};
